module.exports = __webpack_public_path__ + "img/alexhead_06.48a1f43d.svg";